module.exports = __webpack_public_path__ + "img/工厂@0.5x.0541b0b8.png";